/**
 * Flag-gated public Tools nav items (shared so Header + unit tests stay aligned).
 */
import {
  SCORECARD_LANDING_PATH,
  SCORECARD_PRODUCT_NAME,
} from '../scorecard/readinessScorecardConfig.js';
import { TCOLE_PSR_LANDING_PATH, TCOLE_PSR_PRODUCT_NAME } from './psrToolConfig.js';

export type PublicToolsNavItem = {
  text: string;
  path: string;
  id: 'tcole-psr' | 'scorecard-readiness';
};

export function buildPublicToolsNavItems(flags: {
  tcoleEnabled: boolean;
  scorecardEnabled: boolean;
}): PublicToolsNavItem[] {
  const items: PublicToolsNavItem[] = [];
  if (flags.tcoleEnabled) {
    items.push({
      id: 'tcole-psr',
      text: TCOLE_PSR_PRODUCT_NAME,
      path: TCOLE_PSR_LANDING_PATH,
    });
  }
  if (flags.scorecardEnabled) {
    items.push({
      id: 'scorecard-readiness',
      text: SCORECARD_PRODUCT_NAME,
      path: SCORECARD_LANDING_PATH,
    });
  }
  return items;
}

export function isPublicToolsNavVisible(flags: {
  tcoleEnabled: boolean;
  scorecardEnabled: boolean;
}): boolean {
  return buildPublicToolsNavItems(flags).length > 0;
}
